import styled from "styled-components";

export const StyledAbout = styled.section`
  background-color: var(--dark-bg);
  padding: 100px 0;

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  h2 {
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 50px;
    color: var(--text-color);
    font-family: Gunar Thin, sans-serif;
    font-weight: 700;
    letter-spacing: 1.5px;

    .highlight {
      color: var(--primary-color);
    }
  }
`;

export const AboutContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  align-items: start;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

export const AboutText = styled.div`
  p {
    margin-bottom: 20px;
    color: var(--text-secondary);
    text-align: justify;
    line-height: 1.6;
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    font-size: 20px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 992px) {
    order: 2;
  }
`;

export const AboutMVV = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;

  .mvv-cards {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    width: 100%;
    max-width: 600px;
  }

  .card {
    background-color: var(--card-bg, #1c1c1c);
    border-radius: 16px;
    padding: 20px;
    color: var(--text-color);
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    font-family: "Poppins", sans-serif;
    text-align: left;
    font-size: 0.95rem;
    line-height: 1.5;
    max-width: 100%;
  }

  .card h3 {
    font-size: 1.8rem;
    color: var(--primary-color);
    margin-bottom: 15px;
    font-family: "Gunar Thin", sans-serif;
    letter-spacing: 0.1em;
  }

  .card p {
    font-size: 1rem;
    line-height: 1.6;
    color: var(--text-secondary);
  }

  .card ul.valores-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px 20px;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .card ul.valores-list li {
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--text-secondary);
    font-size: 1rem;
    line-height: 1.6;
  }

  .card ul.valores-list li svg {
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    .card ul.valores-list {
      grid-template-columns: 1fr;
    }
  }

  .card:hover {
    transform: translateY(-10px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
  }

  @media (max-width: 992px) {
    .mvv-cards {
      flex-direction: column;
      align-items: center;
    }

    .card {
      max-width: 100%;
    }

    order: 1;
  }
`;
